// Nur eigene Build-Assets zählen. Drittanbieter-Skripte (Stripe, Cal.com, ...)
// hängen zur Laufzeit im DOM, stehen aber nie im Asset-Manifest.
export const APP_SCRIPT_PATH_PREFIX = "/static/js/";

export function collectAppScriptSources(scriptElements) {
  return Array.from(scriptElements)
    .map((script) => {
      try {
        const url = new URL(script.getAttribute("src"), window.location.href);
        if (url.origin !== window.location.origin) return "";
        if (!url.pathname.startsWith(APP_SCRIPT_PATH_PREFIX)) return "";
        return `${url.pathname}${url.search}`;
      } catch {
        return "";
      }
    })
    .filter(Boolean)
    .sort();
}

export function normalizeScriptSources(html) {
  if (!html) return [];
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return collectAppScriptSources(doc.querySelectorAll("script[src]"));
}

export function getCurrentScriptSources() {
  return collectAppScriptSources(document.querySelectorAll("script[src]"));
}

export function normalizeManifestEntrypoints(manifest) {
  return Array.isArray(manifest?.entrypoints)
    ? manifest.entrypoints
        .filter((entry) => typeof entry === "string" && /\.js($|\?)/.test(entry))
        .map((entry) => (entry.startsWith("/") ? entry : `/${entry}`))
        .filter((entry) => entry.startsWith(APP_SCRIPT_PATH_PREFIX))
        .sort()
    : [];
}

export function hasScriptSetChanged(nextScripts, currentScripts) {
  if (nextScripts.length === 0 || currentScripts.length === 0) return false;
  if (nextScripts.length !== currentScripts.length) return true;
  return nextScripts.some((src, index) => src !== currentScripts[index]);
}

export async function fetchLatestScriptSources() {
  const manifestResponse = await fetch(`/asset-manifest.json?v=${Date.now()}`, {
    cache: "no-store",
    credentials: "same-origin",
    headers: { "Cache-Control": "no-cache" },
  }).catch(() => null);

  if (manifestResponse?.ok) {
    const manifest = await manifestResponse.json().catch(() => null);
    const entries = normalizeManifestEntrypoints(manifest);
    if (entries.length > 0) return entries;
  }

  const response = await fetch(`/index.html?v=${Date.now()}`, {
    cache: "no-store",
    credentials: "same-origin",
    headers: { "Cache-Control": "no-cache" },
  });
  if (!response.ok) return [];
  const html = await response.text();
  return normalizeScriptSources(html);
}

export function parseSemver(value) {
  const match = String(value || "").trim().match(/^(\d+)\.(\d+)\.(\d+)$/);
  if (!match) return null;
  return match.slice(1).map((part) => Number(part));
}

export function isNewerReleaseVersion(nextVersion, currentVersion) {
  const next = parseSemver(nextVersion);
  const current = parseSemver(currentVersion);
  if (!next || !current) return false;
  for (let index = 0; index < 3; index += 1) {
    if (next[index] > current[index]) return true;
    if (next[index] < current[index]) return false;
  }
  return false;
}
